import { createFileRoute } from "@tanstack/react-router";
import { DistributorsPage } from "@/components/contacts/DistributorsPage";
import { distributorsSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/distributors")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => distributorsSeo(loaderData?.href ?? "/distributors"),
  component: DistributorsPage,
});
